<script>
    // CommitChart.js
    import {Doughnut} from 'vue-chartjs'

    export default {
        extends: Doughnut,
        data() {
            return {
                gradient: null,
                lastData: this.data
            }
        },
        props: {
            labels: {
                required: true,
                type: Array
            },
            data: {
                required: true,
                type: Array
            },
            title: {
                type: String,
                default: ''
            },
            centerTitle: {
                type: String,
                default: ''
            },
            centerText: {
                type: String,
                default: ''
            },
            width: {
                type: Number,
                default: 500
            },
            height: {
                type: Number,
                default: 500
            }
        },
        computed: {
            chartData: function () {
                return this.data;
            }
        },
        mounted() {
            this.renderPieChart(true);
            window.addEventListener('resize',function (){
                this.reRender(false)
            }.bind(this));
        },
        methods: {
            renderPieChart(animated) {
                this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.width);
                this.$refs.canvas.style['max-width'] = this.width + 'px';
                this.$refs.canvas.style['max-height'] = this.width + 'px';
                this.gradient.addColorStop(0, '#da2567');
                this.gradient.addColorStop(0.33, '#b92972');
                this.gradient.addColorStop(0.66, '#752b77');
                this.gradient.addColorStop(1, '#30afe4');
                const options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: animated ? 1000 : 0
                    },
                    legend: {
                        display: false
                    },
                    title: {
                        display: this.title !== '',
                        text: this.title
                    },
                    cutoutPercentage: 70,
                    elements: {
                        center: {
                            text: this.centerText,
                            color: '#394956',
                            title: this.centerTitle,
                            sidePadding: 20
                        }
                    }
                };
                // Overwriting base render method with actual data.
                this.renderChart({
                    labels: this.labels,
                    datasets: [
                        {
                            backgroundColor: this.gradient,
                            data: this.data
                        }
                    ]
                }, options)
            },
            arrayDiff(a, b) {
                return [...b.reduce( (acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                    a.reduce( (acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map() )
                )].reduce( (acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), [] );
            },
            reRender(animated){
                this._data._chart.destroy();
                this.renderPieChart(animated);
            }

        },
        watch: {
            data: function () {
                if (this.arrayDiff(this.data, this.lastData).length > 0) {
                    this.lastData = this.data;
                    this.reRender(true);
                }
            }
        }
    }
</script>

<style scoped>

    canvas {
        background-color: white;
        padding: 12px;
        margin: auto;
    }

    @media (max-width: 767px) {
        canvas {
            min-width: 90%;
        }
    }

</style>